import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.detailLinkIsURL || (_vm.townUrl && _setup.isMobile)
    ? _c(
        "div",
        { staticClass: "d-flex flex-column ga-2 align-center" },
        [
          _setup.isMobile
            ? [
                _setup.detailLinkIsURL
                  ? _c(
                      VBtn,
                      {
                        staticClass: "w-100",
                        attrs: {
                          color: _vm.townUrl ? "primary" : "bg-primary",
                          href: _vm.detailAppointmentLink,
                          depressed: "",
                        },
                        on: { click: _setup.handleClickDetailButton },
                      },
                      [
                        _c(
                          "span",
                          { class: { "primary--text": !_vm.townUrl } },
                          [_vm._v("Детали записи")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.townUrl
                  ? _c(
                      VBtn,
                      {
                        staticClass: "w-100",
                        attrs: {
                          color: _setup.detailLinkIsURL
                            ? "bg-primary"
                            : "primary",
                          href: _vm.townUrl,
                          depressed: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: { "primary--text": _setup.detailLinkIsURL },
                          },
                          [_vm._v("На главную")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _c(
                VBtn,
                {
                  attrs: {
                    color: "bg-primary",
                    href: _vm.detailAppointmentLink,
                    depressed: "",
                  },
                  on: { click: _setup.handleClickDetailButton },
                },
                [
                  _c("span", { staticClass: "primary--text" }, [
                    _vm._v("Детали записи"),
                  ]),
                ]
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }